<script>
import {onBeforeUnmount, onMounted, ref, watchEffect} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import router from "@/router";
import {useRoute} from "vue-router";

export default {
  name: "AuctionInformation",
  components: {LoadingPage},
  setup() {

    let sid = FreeWorld.PinkMan(localStorage.getItem('sid') , 'de')
    let loading = ref(false)

    let data_bid = ref(null)

    let bid_id = useRoute().params.bid

    let privacy = ref(false)

    let time = ref('00:00:00')
    let hours = ref([])
    let minutes = ref([])
    let seconds = ref([])

    function load_bids(load) {

      if (load) loading.value = true

      FreeWorld.Heisenberg({}, 'shop/my_bids', true).then((res) => {

        loading.value = false

        let check

        res.data.forEach((item) => {
          if (item.id == bid_id) {

            if (item.sid !== sid) router.push({name:'MyAuctions'})

            data_bid.value = item
            time.value = item.timer
            check = true
            return false
          }
        })

        if (!check) router.push({name:'MyAuctions'})

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_bids)
      })


    }
    load_bids(true)

    function decreaseTimer() {
      let [hour, minute, second] = time.value.split(':').map(Number);

      second--;

      if (second < 0) {
        second = 59;
        minute--;

        if (minute < 0) {
          minute = 59;
          hour--;

          if (hour < 0) {
            hour = 0;
            minute = 0;
            second = 0;
            router.push({name:'AuctionsPage'})
            // Add actions if timer ends
          }
        }
      }

      time.value = `${hour}:${minute}:${second}`;
    }

    watchEffect(() => {
      let [hour, minute, second] = time.value.split(':').map(Number);

      hours.value = hour.toString().padStart(2, '0').split('');
      minutes.value = minute.toString().padStart(2, '0').split('');
      seconds.value = second.toString().padStart(2, '0').split('');
    });

    let update_timer = null
    let update_bids = null
    onMounted(() => {
      update_timer = setInterval(decreaseTimer, 1000);
      update_bids = setInterval(() => {
        load_bids(false)
      }, 10000);
    })
    onBeforeUnmount(() => {
      clearInterval(update_timer)
      clearInterval(update_bids)
    })

    return {

      time,
      hours,
      minutes,
      seconds,
      loading,
      data_bid,
      privacy,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p v-if="data_bid !== null" dir="rtl" class="animate__animated animate__fadeIn font-color font-4 font-bold">{{ data_bid.name }}</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="data_bid !== null" class="p-body mt-3 animate__animated animate__fadeIn">

      <div class="bg-white shadow-custom rounded-4 p-3 d-flex align-items-center justify-content-between">
        <p class="font-4">تا پایان مزایده</p>

        <div class="d-flex align-items-center w-70">
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center">{{
              seconds[1]
            }}</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center mr-1">{{
              seconds[0]
            }}</span>
          <span class="font-bold d-flex justify-content-center align-items-center mx-1">:</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center">{{
              minutes[1]
            }}</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center mr-1">{{
              minutes[0]
            }}</span>
          <span class="font-bold d-flex justify-content-center align-items-center mx-1">:</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center">{{
              hours[1]
            }}</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center mr-1">{{
              hours[0]
            }}</span>
        </div>
      </div>


      <div class="bg-white rounded-4 shadow-custom p-3 my-4">
        <div class="d-flex align-items-center">
          <img style="height: 20px" src="../assets/img/user-_2_.svg" alt="">

          <p class="font-4 mx-2">نفرات شرکت کننده :</p>

          <p class="font-4 d-flex align-items-center font-color font-bold">
            <span class="ml-1">{{ data_bid.entries }}</span>
            <span class="font-5">نفر</span>
          </p>
        </div>

        <div class="div_hr my-3"></div>

        <div class="d-flex align-items-center">
          <img style="height: 20px" src="../assets/img/increase.svg" alt="">

          <p class="font-4 mx-2">مبلغ هر گام :</p>

          <p class="font-4 d-flex align-items-center font-bold font-color">
            <span class="ml-1">{{ data_bid.price_step.toLocaleString() }}</span>
            <span class="font-5">تومان</span>
          </p>
        </div>

        <div class="div_hr my-3"></div>

        <div class="d-flex align-items-center">
          <img style="height: 20px" src="../assets/img/hammer.svg" alt="">

          <p class="font-4 mx-2">آخرین پیشنهاد :</p>

          <p class="font-4 d-flex align-items-center font-color font-bold">
            <span class="ml-1">{{ data_bid.price_last.toLocaleString() }}</span>
            <span class="font-5">تومان</span>
          </p>
        </div>


      </div>

      <div class="bg-color rounded-3 p-3 shadow-custom d-flex align-items-center mb-3">
        <img style="height: 25px" src="../assets/img/bid-_2_.svg" alt="">

        <p class="font-4 font-bold text-white mr-3">پیشنهادات مزایده</p>
      </div>

      <div class="overflow-hidden">
        <div class="list">

          <div v-for="item in data_bid.offers" :key="item.id"
               class="offer animate__animated animate__fadeInDown p-3 rounded-3 d-flex align-items-center justify-content-between mb-2 shadow-custom">
            <div class="w-30">
              <p class="font-4 font-color">{{ item.name }}</p>
            </div>

            <p class="font-4 d-flex align-items-center font-color">
              <span class="">{{ item.price.toLocaleString() }}</span>
              <span class="font-5 mr-1">تومان</span>
            </p>

            <p class="font-5 font-color">{{ item.time }}</p>
          </div>

        </div>
      </div>

    </div>
  </div>

</template>


<style scoped>

.item_time {
  width: 8vw;
  height: 4vh;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.list > .offer:nth-child(odd) {
  background-color: #9FDBF7;
}

.list {
  max-height: 40vh;
  overflow-y: scroll;
}


</style>